module.exports = __webpack_public_path__ + "img/new-chat.f115835a.svg";